// Delegerade lyssnare eftersom innehållet renderas av Blazor-komponenten
document.addEventListener("click", function (e) {
    const addCourseDialog = document.querySelector("#addCourseDialog");
    if (addCourseDialog) {
        if (e.target.closest(".button--add-course")) {
            addCourseDialog.showModal();
        } else if (e.target.closest("#closeAddCourseDialog, #cancelAddCourseDialog")) {
            addCourseDialog.close();
        }
    }

    // Stäng radera-dialogen om man klickar utanför den
    const removeDialog = document.querySelector("#remove-course-dialog");
    if (removeDialog && e.target === removeDialog) {
        removeDialog.close();
    }
});

// Anropas från CompletedCoursesComponent
window.completedCourses = {
    closeAddCourseDialog: function () {
        document.querySelector("#addCourseDialog")?.close();
    },
    // Blazor sätter klassen "invalid" på fält som inte klarar valideringen
    focusFirstInvalidField: function () {
        const field = document.querySelector("#addCourseDialog .invalid");
        if (field) {
            field.focus();
            field.scrollIntoView({ block: "center" });
        }
    },
    openRemoveCourseDialog: function () {
        document.querySelector("#remove-course-dialog")?.showModal();
    },
    closeRemoveCourseDialog: function () {
        document.querySelector("#remove-course-dialog")?.close();
    }
};